/* 전역 토스트·확인창 런타임 — 외부화본 (2026-08-07 2차 간소화)
 *
 * 원래 src/layouts/global-header.ts 의 _globalScripts() 안 인라인 <script> 다(5,883 B).
 * ★근로자·회사관리·플랫폼·로그인/가입 전 화면★ 에 매번 실렸다 — 화면을 옮길 때마다
 * 같은 5,883 B 를 다시 받고 다시 파싱했다(HTTP 캐시도 V8 코드 캐시도 못 탄다).
 *
 * 담고 있는 것: window.showToast / window.showConfirm (토스트 컨테이너는 마크업 쪽).
 * 보간 0개 — 어느 포털에서 렌더해도 바이트가 완전히 같다(3포털 md5 일치 확인).
 *
 * 주의 1: 이 파일을 부르는 <script> 에 defer/async 를 붙이지 말 것 —
 *         원래 인라인은 그 자리에서 ★동기 실행★ 됐고, 뒤따르는 마크업 onclick 이
 *         showToast 를 곧바로 부른다.
 * 주의 2: 서버 보간(${) 을 절대 넣지 말 것 — 정적 파일이라 그대로 노출된다.
 */
    // ── 전역 토스트 ────────────────────────────────────────────────
    /* ★One UI 토스트 (디자인 정본 v1 §9 · 2026-10-04)★ — 화면 아래 가운데 알약(모서리 full).
       한 줄이 기본이고 길어도 ★3줄에서 말줄임★ 한다. 하단 탭·홈 표시줄 위(--app-bottom-obstruction).
       컨테이너 위치는 ★처음 띄울 때 여기서 입힌다★ — 마크업(global-header.ts)의 인라인을 고치면
       전 화면 HTML 지문이 바뀌고, ds.css 로는 인라인을 이길 수 없다.
       등장 0.25s cubic-bezier(0.22,0.25,0,1) · 사라짐 ease-in · 움직임 줄이기면 즉시. */
    window.showToast = function(message, type, duration) {
      type     = type     || 'success';
      duration = duration || 3000;
      var container = document.getElementById('toast-container');
      if (!container) return;
      if (container.getAttribute('data-ou') !== '1') {
        container.setAttribute('data-ou', '1');
        container.style.cssText = 'position:fixed;left:50%;bottom:calc(var(--app-bottom-obstruction, 0px) + 16px);transform:translateX(-50%);z-index:9998;display:flex;flex-direction:column;align-items:center;gap:8px;width:max-content;max-width:min(calc(100vw - 32px), 420px);pointer-events:none';
      }
      var reduce = false;
      try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) {}
      /* 아이콘 색은 짙은 알약 위에서 읽히는 옅은 단계(종전 테두리 색)를 쓴다 — 색 + 아이콘 모양으로 종류를 알린다. */
      var colorMap = {
        success: { icon: 'fa-check-circle',        iconColor: '#a7f3d0' },
        error:   { icon: 'fa-times-circle',        iconColor: '#fca5a5' },
        info:    { icon: 'fa-info-circle',         iconColor: '#93c5fd' },
        warning: { icon: 'fa-exclamation-circle',  iconColor: '#fcd34d' },
      };
      var cfg = colorMap[type] || colorMap.success;
      var el  = document.createElement('div');
      el.setAttribute('role', 'status');
      el.style.cssText = 'pointer-events:auto;display:flex;align-items:center;gap:8px;box-sizing:border-box;max-width:100%;padding:10px 20px;border-radius:9999px;background:#1e293b;color:#ffffff;font-size:15px;font-weight:600;line-height:1.4;transform:translateY(16px);opacity:0'
        + (reduce ? '' : ';transition:opacity .25s linear,transform .25s cubic-bezier(0.22,0.25,0,1)');
      /* ★문구는 textContent 로만 넣는다★ — 부르는 쪽이 이름·부서명·회사명을 이어 붙여 넘긴다(자유 입력).
         문자열을 HTML 로 해석하지 않는다 — 태그를 넘겨도 글자로 보인다. 계약: tests/unit/admin-name-innerhtml-xss.test.ts */
      el.innerHTML = '<i class="fas ' + cfg.icon + '" style="color:' + cfg.iconColor + ';font-size:16px;flex-shrink:0"></i><span style="min-width:0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;word-break:keep-all;overflow-wrap:anywhere"></span>';
      el.querySelector('span').textContent = message == null ? '' : String(message);
      container.appendChild(el);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          el.style.transform = 'none';
          el.style.opacity   = '1';
        });
      });
      setTimeout(function() {
        if (!reduce) el.style.transition = 'opacity .15s linear,transform .15s cubic-bezier(0.4,0,1,1)';
        el.style.transform = 'translateY(16px)';
        el.style.opacity   = '0';
        setTimeout(function() { el.remove(); }, 300);
      }, duration);
    };

    // ── 인터넷 끊김 문구 (R-958 · 시안 C13) ─────────────────────────
    /* fetch 가 네트워크에서 끊기면 브라우저 영어 글(Chrome 「Failed to fetch」 · Safari 「Load failed」 ·
       Firefox 「NetworkError when attempting to fetch resource.」)이 e.message 로 온다 — 그대로 토스트에 뜨면 안 된다.
       그 글이면 한국어 한 문장, 아니면 '' 를 돌려준다 → 부르는 쪽은 `insNetErrText(e) || (기존 식)`.
       서버가 준 한국어 오류는 걸리지 않아 그대로 지나간다. 시험: tests/unit/r958-net-error-korean.test.ts */
    window.insNetErrText = function(e) {
      var m = e && e.message ? String(e.message) : '';
      return /^(Failed to fetch|Load failed|NetworkError\b|Network request failed|The Internet connection appears to be offline|The network connection was lost)/i.test(m)
        ? '저장하지 못했어요. 인터넷 연결을 확인하고 다시 눌러 주세요.' : '';
    };

    // ── 전역 확인 모달 ──────────────────────────────────────────────
    window.showConfirm = function(opts) {
      var title       = opts.title       || '확인';
      var message     = opts.message     || '';
      var confirmText = opts.confirmText || '확인';
      var cancelText  = opts.cancelText  || '취소';
      /* DESIGN.md §4.1: default confirm = brand-600 (#2B74FB). One UI 글자 버튼이라 이 색은 ★글자색★ 이다. */
      var confirmColor = opts.confirmColor
        ? (opts.confirmColor.includes('emerald') ? '#059669' : opts.confirmColor.includes('red') ? '#dc2626' : '#2B74FB')
        : '#2B74FB';
      var onConfirm   = opts.onConfirm;
      var onCancel    = opts.onCancel;

      var existing = document.getElementById('global-confirm-modal');
      if (existing) existing.remove();

      /* ★One UI 모양 — 정본은 /static/app-dialogs.js 의 insConfirm 과 같은 값이다★ (디자인 정본 v1 §7·§8·§9).
         모바일은 화면 아래쪽(하단 탭 위) · 모서리 24 · 그림자 없음 · 뒤는 옅게 어둡게+흐림 ·
         글자 버튼 · 0.25s cubic-bezier(0.22,0.25,0,1) · 움직임 줄이기면 즉시. 누름 표시는 ds.css 의 .ins-dlg-btn.
         폭 판정은 ds.css(design-oneui.ts)가 --ins-dlg-* 변수로 넘긴다 — PC 경계 리터럴을 여기 다시 적지 않는다. */
      var reduce = false;
      try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) {}
      var from = 'var(--ins-dlg-from, scale(0.96))';
      var btnBase = 'flex:1;min-height:44px;padding:10px 12px;border:0;border-radius:18px;background:transparent;font-size:16px;cursor:pointer;font-family:inherit;line-height:1.3';

      var modal = document.createElement('div');
      modal.id  = 'global-confirm-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:9997;display:flex;align-items:var(--ins-dlg-align, center);justify-content:center;padding:var(--ins-dlg-pad, 16px)';
      modal.innerHTML =
        '<div id="modal-backdrop" style="position:absolute;inset:0;background:rgba(15,23,42,0.28);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);opacity:0' + (reduce ? '' : ';transition:opacity .25s linear') + '"></div>' +
        '<div id="modal-box" style="position:relative;box-sizing:border-box;background:#ffffff;border-radius:24px;padding:24px 20px 12px;width:100%;max-width:420px;transform:' + from + ';opacity:0' + (reduce ? '' : ';transition:transform .25s cubic-bezier(0.22,0.25,0,1),opacity .25s linear') + '">' +
          '<div data-confirm-fill="title" style="color:#0f172a;font-weight:700;font-size:20px;line-height:1.3;margin-bottom:8px"></div>' +
          '<div data-confirm-fill="message" style="color:#475569;font-size:16px;margin-bottom:16px;line-height:1.5;word-break:keep-all;overflow-wrap:anywhere"></div>' +
          '<div style="display:flex;gap:4px;margin:0 -8px">' +
            '<button id="modal-cancel" class="ins-dlg-btn" style="' + btnBase + ';color:#475569;font-weight:600"></button>' +
            '<button id="modal-confirm" class="ins-dlg-btn" style="' + btnBase + ';color:' + confirmColor + ';font-weight:700"></button>' +
          '</div>' +
        '</div>';
      /* ★제목·문구·버튼 글자는 textContent 로 채운다★ — 문구에 신청자 이름 같은 자유 입력이 실린다.
         문자열을 HTML 로 해석하지 않는다(태그를 넘겨도 글자로 보인다). */
      modal.querySelector('[data-confirm-fill="title"]').textContent = String(title);
      modal.querySelector('[data-confirm-fill="message"]').textContent = String(message);
      modal.querySelector('#modal-cancel').textContent = String(cancelText);
      modal.querySelector('#modal-confirm').textContent = String(confirmText);
      document.body.appendChild(modal);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          var box = document.getElementById('modal-box');
          var veil = document.getElementById('modal-backdrop');
          if (box) { box.style.transform = 'none'; box.style.opacity = '1'; }
          if (veil) veil.style.opacity = '1';
        });
      });

      function closeModal() {
        var box = document.getElementById('modal-box');
        var veil = document.getElementById('modal-backdrop');
        if (box) {
          if (!reduce) box.style.transition = 'transform .15s cubic-bezier(0.4,0,1,1),opacity .15s linear';
          box.style.transform = from; box.style.opacity = '0';
        }
        if (veil) veil.style.opacity = '0';
        setTimeout(function() { modal.remove(); }, 200);
      }
      document.getElementById('modal-cancel').onclick   = function() { closeModal(); if (onCancel)  onCancel();  };
      document.getElementById('modal-confirm').onclick  = function() { closeModal(); if (onConfirm) onConfirm(); };
      document.getElementById('modal-backdrop').onclick = function() { closeModal(); if (onCancel)  onCancel();  };
    };
